import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { Router } from "@angular/router";
/**
 * VerifyComponent
 */
let PendingScreenComponent = class PendingScreenComponent {
    constructor(httpClient, webSettingsService, sanitizer, themeService, router, auth) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.auth = auth;
        this.secondColor = '';
        this.backColor = '';
        this.linkColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.successColor = '';
        this.borderRadiusLarger = '';
        this.userData = {};
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.fetchUser();
    }
    backToHome() {
        this.router.navigateByUrl('');
    }
    fetchUser() {
        this.auth.fetchUser().then((result) => {
            this.userData = JSON.parse(localStorage.getItem('user'));
            const pendingStatuses = ['TRADE_CORE_CREATE_APPLICANT_FAILED', 'TRADE_CORE_UPDATE_USER_FAILED', 'TRADE_CORE_CREATE_USER_FAILED', 'USER_NOT_FOUND', 'TRADE_CORE_CREATE_IDENTITY_CHECK_FAILED', 'SDK_TOKEN_NOT_GENERATED', 'REQUEST_DOCUMENT_CHECK_FAIL', 'REQUEST_DOCUMENT_CHECK_SUCCESS'];
            if (!pendingStatuses.includes(this.userData.user_settings.check_status_verbose_id) && !this.userData.proof_of_address_submitted) {
                this.router.navigate(['/']);
            }
        });
    }
};
PendingScreenComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: AuthService }
];
PendingScreenComponent = __decorate([
    Component({
        selector: 'ecd-pending-screen',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./pending-screen.html")).default
    })
], PendingScreenComponent);
export { PendingScreenComponent };
